const AdproRoutes = {
  register: "/adpro/register",
  uploadFile: "ad/uploadFiles"
}

export default AdproRoutes;